import { render, staticRenderFns } from "./Manage-Delivery-Methods.vue?vue&type=template&id=8ae5f9ca"
import script from "./Manage-Delivery-Methods.vue?vue&type=script&lang=js"
export * from "./Manage-Delivery-Methods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports